import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/reset.less'
import Antd from 'ant-design-vue'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import 'ant-design-vue/dist/antd.css'
dayjs.locale('zh-cn')
const app = createApp(App)

app.use(store)

app.use(router)
app.use(Antd)
app.mount('#app')
